const convertFormStateErrorToArray = (errorsObj, prefix = '', idx = 0) => {
  let messages = [];

  Object.entries(errorsObj || {}).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // For field arrays
      value.forEach((v, i) => {
        const collectedErrors = convertFormStateErrorToArray(
          v,
          `${prefix}${key}[${i}].`,
          i + 1,
        );
        messages = [...messages, ...collectedErrors];
      });
    } else if (typeof value === 'object' && value !== null) {
      if (value.message) {
        messages.push({
          field: `${prefix}${key}`,
          message: idx > 0 ? `${value.message} (row ${idx})` : value.message,
        });
      } else {
        messages = [
          ...messages,
          ...convertFormStateErrorToArray(value, `${prefix}${key}.`, idx),
        ];
      }
    }
  });

  return messages;
};

export default convertFormStateErrorToArray;
